import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <>
      <div className="flex flex-col jusitfy-between md:flex-row">
        <div className="md:ml-20 w-full order-2 md:order-1">
          <Outlet />
        </div>
        <div className="w-full flex items-center order-1 md:order-2 md:mr-24">
          <img
            src={process.env.PUBLIC_URL + "/Auth Banner.jpeg"}
            alt="Banner Image"
          />
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
